import { gateway } from '..';

const API_URL = 'legacy-api/v1';
const API_FEED = `${API_URL}/feed`;

export function getRecommendedDocuments() {
    return gateway.get(`${API_FEED}/my_recommended_documents`);
}
